import React, { useMemo } from 'react';

import PropTypes from 'prop-types';
import { getTotals } from '../../../helpers';

const ServicesTableFooter = ({ data }) => {
  const totals = useMemo(() => getTotals(data), [data]);
  return (
    <div className="reports-services-table__footer">
      <table>
        <thead>
          <tr>
            <th className="reports-services-table__header-name">Totals</th>
            <th className="reports-services-table__header-cost">{totals.count_orders}</th>
            <th className="reports-services-table__header-cost">{totals.charge}</th>
            <th className="reports-services-table__header-cost">{totals.cost}</th>
            <th className="reports-services-table__header-cost">{totals.profit}</th>
            <th className="reports-services-table__header-cost">{totals.refunded}</th>
          </tr>
        </thead>
      </table>
    </div>
  )
}

ServicesTableFooter.propTypes = {
  data: PropTypes.array.isRequired,
};

export default ServicesTableFooter;
